import { render, staticRenderFns } from "./ZaplacenoProcent.vue?vue&type=template&id=f2b20c54&"
import script from "./ZaplacenoProcent.vue?vue&type=script&lang=js&"
export * from "./ZaplacenoProcent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports